<template>
  <div class="physioDrugManage" v-loading="loading">
    <div class="filter">
      <el-form ref="form" class="filter_form" :model="form" label-width="80px">
        <el-form-item class="filter_form_item" label="货号">
          <el-input v-model="form.artNo" placeholder="请输入货号" clearable></el-input>
        </el-form-item>
        <el-form-item class="filter_form_item" label="名称">
          <el-input v-model="form.name" placeholder="请输入名称/通用名称" clearable></el-input>
        </el-form-item>
        <el-form-item class="filter_form_item" label="状态">
          <el-select v-model="form.status" placeholder="请选择" clearable>
            <el-option label="待完善" value="0"></el-option>
            <el-option label="已完善" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter_form_item" label="定价方式">
          <el-select v-model="form.configType" placeholder="请选择" clearable>
            <el-option label="固定价格" value="1"></el-option>
            <el-option label="阶梯价格" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter_form_item" label="所属大类">
          <el-select v-model="form.firstCategoryId" placeholder="请选择" @change="firstCategoryChange">
            <el-option v-for="item in firstCategoryList" :key="item.id" :label="item.physioLabel" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter_form_item" label="所属小类">
          <el-select v-model="form.secondCategoryId" placeholder="请选择">
            <el-option v-for="item in secondCategoryList" :key="item.id" :label="item.physioLabel" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="form_btnList">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </div>
      </el-form>
    </div>
    <div class="table">
      <el-table :data="list">
        <el-table-column type="index" :index="tableIndexMethod" label="序号" width="50" fixed="left"></el-table-column>
        <el-table-column label="货号" prop="artNo" min-width="120" fixed="left"></el-table-column>
        <el-table-column label="商品名称" prop="physioKindName" min-width="180" fixed="left"></el-table-column>
        <el-table-column label="小类" prop="secondCategory" min-width="140">
          <template slot-scope="scope">
            <span v-if="!['', null, undefined].includes(scope.row.secondCategory)">{{ scope.row.secondCategory }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="大类" prop="firstCategory" min-width="140">
          <template slot-scope="scope">
            <span v-if="!['', null, undefined].includes(scope.row.firstCategory)">{{ scope.row.firstCategory }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="项目服务时长" prop="serviceTime" min-width="160">
          <template slot-scope="scope">
            <span v-if="!['', null, undefined].includes(scope.row.serviceTime)">{{ scope.row.serviceTime }}分钟</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="医生标准操作时长" prop="executeTime" min-width="160">
          <template slot-scope="scope">
            <span v-if="!['', null, undefined].includes(scope.row.executeTime)">{{ scope.row.executeTime }}分钟</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" min-width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0" class="status_improved">待完善</div>
            <div v-if="scope.row.status === 1" class="status_already">已完善</div>
          </template>
        </el-table-column>
        <el-table-column label="项目默认定价方式" prop="configType" min-width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.configType == 1">固定价格</div>
            <div v-if="scope.row.configType == 2">阶梯价格</div>
          </template>
        </el-table-column>
        <el-table-column label="项目默认价格" min-width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.configType == 1">
              {{ scope.row.fixedPrice }}元/{{ scope.row.executionMode == 10 ? '次': '组' }}
            </div>
            <div v-if="scope.row.configType == 2 && scope.row.ladderPriceConfigs">
              <div v-for="(item, index) in scope.row.ladderPriceConfigs" :key="index">
                <div v-if="item.ladderEndNumber">{{ item.ladderStartNumber }}-{{ item.ladderEndNumber }}{{ scope.row.executionMode == 10 ? '次': '组' }}，{{
                  item.ladderPrice }}元/{{ scope.row.executionMode == 10 ? '次': '组' }}</div>
                <div v-else>{{ item.ladderStartNumber }}{{ scope.row.executionMode == 10 ? '次': '组' }}以上，{{ item.ladderPrice }}元/{{ scope.row.executionMode == 10 ? '次': '组' }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单位" prop="unit" min-width="120"></el-table-column>
        <el-table-column label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="['', '0', 0,-1].includes(deptId)" type="primary" @click="editInfo(scope.row)">编辑</el-button>
            <el-button v-if="['', '0', 0,-1].includes(deptId)" type="primary"
              @click="toEdit(scope.row.spu)">操作设置</el-button>
            <el-button v-if="['', '0', 0,-1].includes(deptId)" type="primary"
              @click="editPrice(scope.row)">价格设置</el-button>
            <!-- <el-button @click="toDetail(scope.row.spu)">查看详情</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination :current-page="pageNo" :page-size="pageSize" background layout="total, prev, pager, next"
        :total="total" @current-change="pageNoChange">
      </el-pagination>
    </div>
    <PhysioDrugEdit ref="physioDrugEdit"></PhysioDrugEdit>
    <PhysioDrugDetail ref="physioDrugDetail"></PhysioDrugDetail>
    <physioEdit ref="physioEdit"></physioEdit>
    <physioPriceEdit ref="physioPriceEdit"></physioPriceEdit>
  </div>
</template>

<script>
import PhysioDrugEdit from './components/physioDrugEdit.vue'
import PhysioDrugDetail from './components/physioDrugDetail.vue'
import physioEdit from './components/physioEdit.vue';
import physioPriceEdit from './components/physioPriceEdit.vue';
import { getPhysioConfigList, getPhysioCategoryList } from '@/api/physio.js'
import { deepClone } from '@/utils/validateBase';
export default {
  name: 'physioDrugManage',
  components: {
    PhysioDrugEdit,
    PhysioDrugDetail,
    physioEdit,
    physioPriceEdit
  },
  data() {
    return {
      deptId: this.$session.get('deptId'),
      loading: false,
      form: {
        artNo: '',
        name: '',
        status: '',
        configType: '',
        firstCategoryId:'',
        secondCategoryId:''
      },
      pageNo: 1,
      pageSize: 10,
      list: [],
      total: 0,
      firstCategoryList: [],
      secondCategoryList: [],
    }
  },
  created() {
    this.getList()
    this.getFirstCategory()
  },
  methods: {
    tableIndexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    async getList() {
      this.loading = true
      const res = await getPhysioConfigList({
        ...this.form,
        pageNum: this.pageNo,
        pageSize: this.pageSize
      })
      this.loading = false
      if (res.code === 200) {
        this.list = res.rows
        this.total = res.total
      }
    },
    pageNoChange(num) {
      this.pageNo = num
      this.getList()
    },
    search() {
      this.pageNo = 1
      this.getList()
    },
    reset() {
      this.form.artNo = ''
      this.form.name = ''
      this.form.status = ''
      this.form.configType = ''
      this.form.firstCategoryId = ''
      this.form.secondCategoryId = ''
      this.pageNo = 1
      this.getList()
    },
    toEdit(spu) {
      this.$refs['physioDrugEdit'].open(spu)
    },
    toDetail(spu) {
      this.$refs['physioDrugDetail'].open(spu)
    },
    editInfo(row) {
      let { artNo, physioCommonName, dictDrugCode, executionMode, perUnit, perUnitCount, unit, physioKindName } = row
      let info = { artNo, physioCommonName, dictDrugCode, executionMode, perUnit, perUnitCount, unit, physioName: physioKindName }
      this.$refs['physioEdit'].open(info)
    },
    editPrice(row) {
      this.$refs['physioPriceEdit'].open(deepClone(row))
    },
    async getFirstCategory() {
      const res = await getPhysioCategoryList()
      if (res.code === 200) {
        this.firstCategoryList = res.data.filter(v => v.level === 1)
      }
    },
    async getSecondCategory() {
      if (['', null, undefined].includes(this.form.firstCategoryId)) {
        this.secondCategoryList = []
      } else {
        const res = await getPhysioCategoryList({ categoryId: this.form.firstCategoryId })
        if (res.code === 200) {
          this.secondCategoryList = res.data || []
        }
      }
    },
    firstCategoryChange() {
      this.form.secondCategoryId = ''
      this.getSecondCategory()
    },
  }
}
</script>

<style lang="less" scoped>
.physioDrugManage {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
}

.filter {
  width: 100%;
}

.filter_form {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: -20px;
  width: 100%;
  overflow: hidden;
}

.filter_form /deep/ .el-form-item__label {
  line-height: 32px;
  color: #1F2329;
}

.filter_form /deep/ .el-form-item__content {
  line-height: 32px;
}

.filter_form_item {
  margin: 20px 12px 0 0;
  width: 250px;
}

.form_btnList {
  margin: 20px 0 0 0;
}

.table {
  margin: 20px 0 0 0;
  width: 100%;
}

.status_improved {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
  width: fit-content;
  height: 24px;
  font-size: 14px;
  color: #FF9000;
  background-color: #FFEED8;
  border-radius: 2px;
}

.status_already {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
  width: fit-content;
  height: 24px;
  font-size: 14px;
  color: #667182;
  background-color: #F0F1F3;
  border-radius: 2px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 20px 0 0 0;
  width: 100%;
}
</style>